import { useMutation } from '@apollo/client';
import { COMPLETE_ASSIGNMENT_STEP } from 'graphql/steps/mutations/completeAssignmentStep.gql';

export default function useMutationCompleteAssignmentStep() {
  return useMutation(COMPLETE_ASSIGNMENT_STEP);
}
